/* src/modules/discounts/components/CreateOwner/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { find, isEmpty, map, uniq } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Checkbox,
  Collapse,
  FormControl, FormControlLabel, FormLabel, FormGroup,
  TextField,
  Typography,
  Paper,
  Zoom,
} from '@material-ui/core';
import { Check } from '@material-ui/icons';

import styles from './styles';

class CreateOwner extends React.Component {
  state = {
    expanded: this.props.expanded,
    organization: this.props.organization,
    universities: this.props.universities,
    chooseUniversity: false,
    chosenUniversities: this.props.chosenUniversities,
    ownerName: this.props.ownerName,
    ownerEmail: this.props.ownerEmail,
    ownerPhone: this.props.ownerPhone,
  }

  componentWillReceiveProps(nextProps) {
    const update = {};
    if (this.props.universities !== nextProps.universities)
      update.universities = nextProps.universities;
    if (this.props.chosenUniversities !== nextProps.chosenUniversities)
      update.chosenUniversities = nextProps.chosenUniversities;
    if (this.props.ownerName !== nextProps.ownerName)
      update.ownerName = nextProps.ownerName;
    if (this.props.ownerEmail !== nextProps.ownerEmail)
      update.ownerEmail = nextProps.ownerEmail;
    if (this.props.ownerPhone !== nextProps.ownerPhone)
      update.ownerPhone = nextProps.ownerPhone;
    if (this.props.organization !== nextProps.organization)
      update.organization = nextProps.organization;

    if (!isEmpty(update)) this.setState(update);
  }

  getInfo = () => {
    const { ownerName, ownerEmail, ownerPhone, chosenUniversities } = this.state;
    return { ownerName, ownerEmail, ownerPhone, chosenUniversities };
  };

  toggleExpand = expanded => {
    this.setState({ expanded });
  }

  _onChooseUniversity = id => ({ target: { checked } }) => {
    this.setState(state => {
      if (checked) return { chosenUniversities: uniq([...state.chosenUniversities, id]) };
      return { chosenUniversities: state.chosenUniversities.filter(u => u !== id) };
    });
  }

  _onChangeName = event => {
    this.setState({ ownerName: event.target.value });
  }

  _onChangeEmail = event => {
    this.setState({ ownerEmail: event.target.value });
  }

  _onChangePhone = event => {
    this.setState({ ownerPhone: event.target.value });
  }

  _onClickChooseUniversity = () => {
    this.setState({ chooseUniversity: true });
  }

  _onCloseChooseUniversity = () => {
    this.setState({ chooseUniversity: false });
  };

  renderChooseUniversity = () => {
    const { classes, universities } = this.props;
    const { chooseUniversity, chosenUniversities } = this.state;

    return (
      <Zoom in={chooseUniversity}>
        <Paper className={classes.universityPaper}>
          <div className={classes.universityForm}>
            <FormControl error={chosenUniversities.length < 1} component="fieldset">
              <FormLabel component="legend">
                {'Choose at least one'}
              </FormLabel>
              <FormGroup>
                {map(universities, u => {
                  const checked = find(chosenUniversities, c => c === u._id) != null;
                  return (
                    <FormControlLabel
                      key={u._id}
                      control={
                        <Checkbox
                          color="primary"
                          checked={checked}
                          onChange={this._onChooseUniversity(u._id)}
                          value={u._id}
                        />
                      }
                      label={u.name}
                    />
                  );
                })}
              </FormGroup>
            </FormControl>
          </div>
          <div className={classes.buttonContainer}>
            <Button color="primary" variant="fab" onClick={this._onCloseChooseUniversity}>
              <Check />
            </Button>
          </div>
        </Paper>
      </Zoom>
    );
  }

  render() {
    const { classes } = this.props;
    const {
      ownerName,
      ownerEmail,
      ownerPhone,
      chosenUniversities,
      organization,
      universities,
      expanded,
    } = this.state;
    const universityList = chosenUniversities.reduce((acc, u) => {
      const { name } = universities[u] || { name: 'invalid university' };
      if (!acc) return name;
      return `${acc}, ${name}`;
    }, '');
    return (
      <React.Fragment>
        <Collapse in={expanded} timeout="auto" unmountOnExit className={classes.collapse}>
          <Typography gutterBottom>
            {`Organization: ${organization}`}
          </Typography>
          <div>
            <Typography color={isEmpty(chosenUniversities) ? 'secondary' : 'default'}>
              {`Universities: ${universityList}`}
            </Typography>
            <Button
              size="small"
              variant="outlined"
              color="primary"
              className={classes.chooseUniversityButton}
              onClick={this._onClickChooseUniversity}
            >
              {'Choose Universities'}
            </Button>
          </div>
          <TextField
            className={classes.textField}
            id="owner_name"
            label="Name"
            InputLabelProps={{ shrink: true }}
            value={ownerName}
            onChange={this._onChangeName}
          />
          <TextField
            className={classes.textField}
            id="owner_email"
            label="Email (optional)"
            InputLabelProps={{ shrink: true }}
            value={ownerEmail}
            onChange={this._onChangeEmail}
          />
          <TextField
            className={classes.textField}
            id="owner_phone"
            label="Phone (optional)"
            InputLabelProps={{ shrink: true }}
            value={ownerPhone}
            onChange={this._onChangePhone}
          />
        </Collapse>
        {this.renderChooseUniversity()}
      </React.Fragment>
    );
  }
}

CreateOwner.propTypes = {
  classes: PropTypes.object.isRequired,
  expanded: PropTypes.bool,
  ownerName: PropTypes.string,
  ownerEmail: PropTypes.string,
  ownerPhone: PropTypes.string,
  organization: PropTypes.string.isRequired,
  universities: PropTypes.object.isRequired,
  chosenUniversities: PropTypes.array,
};

CreateOwner.defaultProps = {
  ownerName: '',
  ownerEmail: '',
  ownerPhone: '',
  expanded: true,
  chosenUniversities: [],
};

export default withStyles(styles)(CreateOwner);



// WEBPACK FOOTER //
// ./src/modules/discounts/components/CreateOwner/index.js